export const EmailResponseStatus = {
    SUCCESS: 'Success',
    ERROR: 'Error'
}

export interface EmailResponse {
    result: string;
    message: string;
    email: string;
}